import styled, { css } from 'styled-components'
import { TypoStyles } from 'styles/typography/styles'
import { handleFontSize } from '../font'

const paragraphStyles = css`
  margin-bottom: 0;
`

export const BodyParagraph = styled.p`
  ${TypoStyles};
  ${paragraphStyles};

  font-size: ${() => handleFontSize('lg')};
  line-height: 2 !important;

  * {
    color: ${({ theme }) => theme.primary} !important;
    font-size: ${() => handleFontSize('lg')} !important;
    line-height: 2 !important;
  }

  li {
    margin-left: 12px;
    padding-left: 4px;
  }

  br {
    height: 400px;
  }

  li::marker {
    background-color: ${({ theme }) => theme.primary};
    fill: ${({ theme }) => theme.primary};
    content: '•';
  }
`

export const SubHeaderParagraph = styled.p`
  ${TypoStyles};
  ${paragraphStyles};

  font-size: ${() => handleFontSize('md')};
  line-height: 158%;
`

export const ButtonParagraph = styled.p`
  ${TypoStyles};
  ${paragraphStyles};

  font-size: ${() => handleFontSize('md')};
  line-height: 158%;
`
